export default {
  employee: {
    createCategoryTitle: 'Kategori Oluştur',
    createCategorySubtitle: 'Bu sayfada ürün için kullanılacak kategori oluşturalabilirsiniz.',
    pageTitle: 'Çalışan Listesi',
    pageSubTitle: 'Yeni çalışanlar ekleyebilir, düzenleyebilir ve silebilirsiniz.',
    bonusRatio: 'Prim Oranları'
  },
  employeeRole: {
    createCategoryTitle: 'Kategori Oluştur',
    createCategorySubtitle: 'Bu sayfada ürün için kullanılacak kategori oluşturalabilirsiniz.',
    createCategoryButton: 'Kaydet',
    listPageTitle: 'Görev Listesi',
    listPageSubTitle: 'Yeni görevler ekleyebilir, düzenleyebilir ve silebilirsiniz.',
    deleteRoleQuestion: 'Silmek istediğinizden emin misiniz?',
    deleteCategoryLabel: 'Departman Silme'
  },
  employeeDepartment: {
    createCategoryTitle: 'Kategori Oluştur',
    createCategorySubtitle: 'Bu sayfada ürün için kullanılacak kategori oluşturalabilirsiniz.',
    createCategoryButton: 'Kaydet',
    listPageTitle: 'Departman Listesi',
    listPageSubTitle: 'Yeni departman ekleyebilir, düzenleyebilir ve silebilirsiniz.',
    deleteRoleQuestion: 'Silmek istediğinizden emin misiniz?',
    deleteCategoryLabel: 'Departman Silme'
  },
  positionType: {
    savePositionTypeClass: 'Pozisyon Sınıf Türü Kaydet',
    formTitle: 'Görev Türü',
    editPositionTypeClass: 'Pozisyon Sınıf Türü Güncelle',
    typeOfPositionClass: 'Pozisyon Sınıflandırma Türü',
    typeOfPositionClassLabel: 'Pozisyon Sınıflandırma Türü',
    typeOfPositionClassPlaceHolder: 'Pozisyon Sınıflandırma Türünü seçiniz.',
    typeOfPositionClassRequired: 'Pozisyon Sınıflandırma Türü zorunludur.',
    standartHPWPlaceIsNumber: 'Haftalik calisma saati sayi olmak zorundadir.',
    standartHPW: 'Haftalık Çalışma Saati',
    standartHPWLabel: 'Haftalık Çalışma Saati',
    standartHPWPlaceHolder: 'Haftalık Çalışma Saatini giriniz.',
    standartHPWPlaceRequired: 'Haftalık Çalışma Saati zorunludur.',
    activeTimeFrame: 'Geçerlilik Tarihi',
    activeTimeFrameLabel: 'Geçerlilik Tarihi',
    startLabel: 'Başlangıç',
    stopLabel: 'Bitiş',
    fromDateLabel: 'Başlangıç Tarihi',
    fromDateRequired: 'Başlangıç Tarihi',
    thruDateLabel: 'Bitiş Tarihi',
    posClassNotFoundAlert: 'Öncelikle Pozisyon Sınıflandırma Türü parametresi tanımlamanız gerekmektedir.',
    posRespNotFoundAlert: 'Öncelikle Pozisyon Sorumluluk parametresi tanımlamanız gerekmektedir.',
    editInfo: 'Kaydı Güncelle',
    deleteInfo: 'Kaydı Sil',
    delete: 'Sil',
    deleteNotify: 'Kaydı silmek istediğinize emin misiniz?',
    deleteParameterLabel: 'Parametre Silinecek',
    deleteNotifyHeader: 'Poziston Türü Silinecek!',
    comment: 'Görev Açıklama',
    commentPlaceHolder: 'Açıklama giriniz.',
    commentRequired: 'Açıklama alanı zorunludur.',
    role: 'Rol',
    internalOrg: 'Yönetici Birimi',
    selectOrg: 'Birim Seçiniz',
    selectRole: 'Role Seçiniz',
    options: 'Görev Detay',
    editPositionTypeResp: 'Sorumluk Güncelle',
    editPosHeader: 'Görev Türü Başliğını Düzenle',
    duties: 'Sorumluluklar',
    typeOfDuties: 'Sorumluluk Türü',
    typeOfDutiesRequired: 'Sorumluluk Türü alanı zorunludur.',
    typeOfDutiesPlaceHolder: 'Sorumluluk Türünü giriniz.',
    class: 'Sınıflandırma',
    payment: 'Maaş Aralığı',
    respType: 'Sorumluluk Türü',
    respTypePlaceHolder: 'Sorululuk Türünü giriniz.',
    respTypeRequired: 'Sorululuk Türü zorunludur.',
    newParam: 'Yeni Parametre',
    refresh: 'Yenile',
    description: 'Açıklama',
    loadingError: 'Veriler yüklenirken hata oluştu. :(',
    actives: 'Aktif',
    archives: 'Arşiv',
    new: 'Yeni Görev'
  },
  position: {
    savePosition: 'Pozisyon Kaydet',
    editPosition: 'Pozisyon Güncelle',
    saveFulfillment: 'Pozisyona Personel Atama',
    nameFulfillment: 'Atama Yapılacak Pozisyon',
    positionType: 'Görev',
    name: 'Pozisyon Adı',
    budgetCode: 'Bütçe Kalemi',
    budgetCodePlaceHolder: 'Bütçe Kalemi giriniz.',
    internalOrganization: 'Departman/Birim Adı',
    internalOrganizationPH: 'Pozisyonun Bağlı Olduğu Departman/Birim adını seçiniz.',
    saveReportingStructure: 'Pozisyon Yönetici Birim Kaydet',
    namePlaceHolder: 'Poziston Adı giriniz.',
    nameRequired: 'Poziston Adı zorunludur.',
    reportingStructure: 'Organizasyon Ağacı Düzenle',
    ManagerNotFoundAlert: 'Pozisyonun asli/idari bağımlı olduğu Yönetici Pozisyon bulunamadı!',
    managerPosition: 'Yönetici Birim',
    managerType: 'İdari/Asli Bağlı',
    positionTypePlaceHolder: 'Pozisyona bağlı Görev seçiniz.',
    positionTypeRequired: 'Bu pozisyon için Görev seçmek zorunludur.',
    plannedTimeFrame: 'Planlanan Kadrolaşma Tarihi',
    startLabel: 'Başlangıç',
    stopLabel: 'Bitiş',
    fromDateLabel: 'Başlangıç Tarihi',
    fromDateRequired: 'Başlangıç Tarihi',
    thruDateLabel: 'Bitiş Tarihi',
    responsibilityNotFoundAlert: 'Öncelikle Sorumluluk parametresi tanımlamanız gerekmektedir.',
    responsibilityNotFound: 'Öncelikle kadronun bağlı olduğu göreve sorumluluk eklemeniz gerekmektedir.',
    redirectToPositionType: 'Pozisyon Görevine Sorumluluk Tanımla',
    editInfo: 'Kaydı Güncelle',
    deleteInfo: 'Kaydı Sil',
    organizationChart: 'Şema Organizasyon',
    organizationTree: 'Liste Organizasyon',
    delete: 'Sil',
    deleteNotify: 'Kaydı silmek istediğinize emin misiniz?',
    deleteParameterLabel: 'Parametre Silinecek',
    deleteNotifyHeader: 'Pozisyon Silinecek!',
    comment: 'Pozisyon Açıklama',
    commentPlaceHolder: 'Açıklama giriniz.',
    commentRequired: 'Açıklama alanı zorunludur.',
    role: 'Rol',
    internalOrg: 'Yönetici Birimi',
    selectOrg: 'Birim Seçiniz',
    selectRole: 'Role Seçiniz',
    details: 'Pozisyon Detay',
    editResponsibility: 'Sorumluk Güncelle',
    editPosHeader: 'Görev Türü Başliğını Düzenle',
    duties: 'Sorumluluklar',
    typeOfDuties: 'Sorumluluk Türü',
    typeOfDutiesRequired: 'Sorumluluk Türü alanı zorunludur.',
    typeOfDutiesPlaceHolder: 'Sorumluluk Türünü giriniz.',
    class: 'Sınıflandırma',
    payment: 'Maaş Aralığı',
    respType: 'Sorumluluk Türü',
    respTypePlaceHolder: 'Sorululuk Türünü giriniz.',
    respTypeRequired: 'Sorululuk Türü zorunludur.',
    newParam: 'Yeni Parametre',
    searchFilter: 'Anahtara kelime giriniz...',
    refresh: 'Yenile',
    description: 'Açıklama',
    loadingError: 'Veriler yüklenirken hata oluştu. :(',
    actives: 'Aktif',
    archives: 'Arşiv',
    options: 'Özellikler',
    status: 'Durumu',
    salaryType: 'Calisma Turu',
    exemptType: 'Engel Turu',
    timeType: 'Zaman Turu',
    periodType: 'Periyod',
    fulfillment: 'Kadro Geçmişi',
    jobApply: 'Is Başvuru',
    organization: 'Organizasyon',
    contracted: 'Sözleşmeli Personel',
    salaried: 'Maaşlı Personel',
    exempt: 'Engelli Kadrosu',
    temprorary: 'Geçici Kadro',
    permanent: 'Daimi Kadro',
    fulltime: 'Tam Zamanlı',
    parttime: 'Yarı Zamanlı',
    posRespNotFoundAlert: 'Hata!!! ==> Pozisyon Sorumluluğu bulunamadı.',
    new: 'Yeni Pozisyon',
    managerPositionPH: 'Yönetici Pozisyon Seçiniz...',
    personCount: 'Çalışan Sayısı'
  },
  organization: {
    arearequired: 'Bu alan gereklidir.',
    areanotvalid: 'Geçerli değer giriniz.',
    foundationdaterequired: 'Kuruluş tarihi gereklidir.',
    fullnamerequired: 'Tam ad gereklidir.',
    fullnamenotvalid: 'Tam ad geçerli değil.',
    groupnamerequired: 'Grup adı gereklidir.',
    groupnamenotvalid: 'Grup adı geçerli değil.',
    taxofficenamerequired: 'Vergi dairesi adı gereklidir.',
    taxofficenamenotvalid: 'Vergi dairesi adı geçerli değil.',
    tradechamberregistrationnumberrequired: 'Sicil numarası gereklidir.',
    tradechamberregistrationnumbernotvalid: 'Sicil numarası geçerli değil.',
    provinceRequired: 'Şubelerin şehir bilgisi boş olamaz.'
  },
  person: {
    name: 'Adı',
    savePerson: 'Kişi Kaydet',
    askPermission: 'Sisteme giriş izni verilsin mi?',
    selectPerson: 'Atama Yapılacak Kişi',
    selectPersonPH: 'Kadroya Ataması Yapılacak Kişiyi Seçiniz.',
    fulfilmentDescription: 'İşe Alım Açıklaması',
    fullname: 'Adı Soyadı',
    surname: 'Soyadı',
    search: 'Arama yapınız...',
    appoint: 'Giriş izni ver',
    userName: 'Kullanıcı Adı',
    access: 'Giriş İzni',
    giveAccess: 'Giriş izni vermek istediğinize emin misiniz ?',
    ok: 'Tamam',
    giveCanceled: 'İptal edildi.',
    firstName: 'Adı',
    firstNamePH: 'Çalışan Adı Giriniz',
    firstNameRequired: 'Çalışan Adı girilmesi zorunludur.',
    firstNameNotValid: 'Hatalı Çalışan Adı ! En az 2, En fazla 250 karater girilmesi gerekmektedir.',
    middleName: 'İkinci Adı',
    middleNamePH: 'Çalışan İkinci Adı Giriniz',
    middleNameNotValid: 'Hatalı Çalışan Adı ! En az 2, En fazla 250 karater girilmesi gerekmektedir.',
    lastName: 'Soyadı',
    lastNamePH: 'Çalışan Soyadı Giriniz',
    lastNameRequired: 'Çalışan Soyadı girilmesi zorunludur.',
    lastNameNotValid: 'Hatalı Çalışan Soyadı ! En az 2, En fazla 250 karater girilmesi gerekmektedir.',
    fatherName: 'Baba Adı',
    fatherNamePH: 'Baba Adı Giriniz',
    motherName: 'Anne Adı',
    motherNamePH: 'Anne Adı Giriniz.',
    motherMaidenName: 'Anne Kızlık Soyadı',
    motherMaidenNamePH: 'Anne Kızlık Soyadı Giriniz.',
    idno: 'TCKN',
    birthDay: 'Doğum Tarihi',
    filterByName: 'Personel Adı Giriniz... (En Az Üç Karakter)',
    birthDayPH: 'Doğum Tarihi Seçiniz.',
    birthDayRequired: 'Doğum Tarihi girilmesi zorunludur.',
    position: 'Pozisyon',
    career: 'Kariyer',
    details: 'Detay',
    list: 'ÇALIŞAN LİSTESİ',
    summary: 'Özet',
    process: 'Süreç',
    performance: 'Hedef Girişi',
    notFound: 'Personel kaydına ulaşılamadı...',
    assets: 'Demirbaşlar',
    internalOrganization: 'Çalıştığı Birim',
    fulfillmentDate: 'Başlama Tarihi',
    fulfillmentThruDate: 'Bitiş Tarihi',
    TCKN: 'TC Kimlik No',
    TCKN_PH: 'TC Kimlik No Giriniz.',
    TCKN_Required: 'TC Kimlik Numarası girilmesi zorunludur.',
    TCKN_NotValid: 'Hatalı TC Kimlik Numarası !!!',
    newbee: 'Pozisyona Yeni Çalışan Tanımla',
    deleteNotifyHeader: 'Kişi Silinecek !!!',
    new: 'Yeni Kişi',
    activeEmployee: 'Aktif Çalışanlar',
    inactiveEmployee: 'Atama Bekleyenler',
    filterDescription: 'Bir şeyler yazınız...(TCKN,Ad-Soyad,Görev)',
    passives: 'Pasifler',
    email: 'E-mail',
    phone: 'Telefon',
    superior: 'Yönetici',
    colleagues: 'Meslektaşları',
    rolechart: 'Roller',
    organizationchart: 'İş Ailesi',
    positiontypechart: 'Görevler'
  },
  chart: {
    positionTypePlaceHolder: 'Görev Seçiniz veya Yeni Görev Tanımlayınız',
    new: 'Yeni Pozisyon Tanımla'
  },
  roleType: {
    roleType: 'Rol Türü'
  },
  exception: {
    PositionTypeClassificationAlreadyDefinedWithSameName: ' isimli görev sınıflandırma zaten listede yer almaktadır.',
    PersonAlreadyDefined: ' TC Kimlik numaralı kişi zaten kayıtlıdır.',
    postponeCountAndTermNotValid: 'Taksit atlatma dönemi veya sayısı geçerli değil',
    referenceCountNotValid: 'Geçerli bir referans sayısı giriniz!',
    deliveryAndWorkingCostEmpty: 'Organizasyon ücreti ve tahsisat tarihi aynı anda boş olamaz!',
    OrganizationAlreadyDefined: 'Organizasyon zaten kayıtlıdır',
    validDateLate: 'Teklif Geçerlilik Tarihi dolmuştur',
    OrganizationNotFound: 'Organizasyon bulunamadı.',
    PositionTypeResponsibilityAlreadyDefinedWithSameName: ' isimli görev sorumluluğu zaten listede yer almaktadır.',
    PositionTypeAlreadyDefinedWithSameName: ' isimli görev türü zaten listede yer almaktadır.',
    PositionClassificationTypeAlreadyDefinedWithSameName: ' isimli parametre zaten listede yer almaktadır.',
    ResponsibilityTypeAlreadyDefinedWithSameName: ' isimli parametre zaten listede yer almaktadır.',
    PositionResponsibilityAlreadyDefinedWithSameName: ' isimli görev sorumluluğu zaten listede yer almaktadır.',
    cantGetPositions: 'Hata... Pozisyon listesi alınamadı.',
    cantGetPositionTypes: 'Hata... Görev Listesi alınamdı.',
    PersonAlreadyHoldThePosition: 'Eklemek istediğiniz personel zaten bir kadroya atanmış durumdadır.',
    PersonAlreadyHoldThePositionForDelete: 'Silmek istediğiniz personel bir kadroya atanmış durumdadır. Lütfen önce kadrodan çıkarınız.'
  },
  parameter: {
    deleteDialogHeader: 'Silme işlemi öncesi parametrenin kullanıldığı kayıtlar kontrol ediliyor...',
    name: 'Adı',
    ratio: 'Oran',
    bonusRateType: 'Oran Tipi',
    nameRequired: 'Ad gereklidir',
    ratioRequired: 'Oran gereklidir',
    rateType: 'Tip',
    level: 'Kademe',
    min: 'Minimum değer',
    minRequired: 'Minimum değer gereklidir',
    max: 'Maksimum değer',
    maxRequired: 'Maksimum değer gereklidir',
    levelRequired: 'Kademe gereklidir',
    roleType: 'Kıdem',
    roleTypeRequired: 'Kıdem gereklidir',
    description: 'Açıklama',
    descriptionRequired: 'Açıklama gereklidir',
    bonusQuota: 'Çalışan-Kota',
    managerBonus: 'Şube Prim',
    bonus: 'Pirim',
    bonusRequired: 'Pirim gereklidir'
  },
  errorHR: {
    passwordDoesNotMatch: 'Girilen eski şifreniz hatalı!',
    existPortfolioName: 'Portföy adı sistemimizde bulunmaktadır.',
    existPortfolioOwner: 'Portföy sahibi sistemimizde bulunmaktadır.',
    existBranch: 'Portföy şubesi seçilmemiş.',
    serviceName: 'Aynı isimde kullanıcı sistemde bulunmaktadır.',
    existServiceType: 'Aynı servis tipi sistemimizde bulunmaktadır.',
    existServiceName: 'Bu servis ismi sistemimizde bulunmaktadır.'
  }
};